
namespace RedBullMOBILE360.SMSCodes {
    export class InformativeSmsColumns {
        static columnsKey = 'SMSCodes.InformativeSms';
    }
}